import { Autocomplete, TextField } from '@mui/material'
import { OrganizationModel } from '../../models/organization.model'
import { buttonLabels } from '../shared/constants'
import {
    ImportColumnChip,
    ImportInfoBanner,
    ImportStepCard,
    ImportStepFooter,
    ImportStepLayout,
    USER_IMPORT_COLUMNS
} from './import-users-shared.component'

interface IProps {
    Organizations: OrganizationModel[]
    SelectedOrgId: string
    IsDarkMode: boolean
    OnChangeOrg: (organizationId: string) => void
    OnCancel: () => void
    OnContinue: () => void
}

const SelectOrganizationStep = (props: IProps) => {
    const selectedOrganization = props.Organizations.find((org) => org.ID === props.SelectedOrgId) || null
    const organizationOptions = props.Organizations.filter((org) => org.Name !== null && !org.IsDeleted)
    const canContinue = !!props.SelectedOrgId

    return (
        <ImportStepLayout
            isDarkMode={props.IsDarkMode}
            left={
                <>
                    <ImportInfoBanner title="One organization per upload">
                        Every user in the file joins the organization you pick here, and their numbers are checked against that organization’s hosted numbers. To onboard a second organization, run a second upload.
                    </ImportInfoBanner>

                    <div className='h5-medium color-primary-accent mt-3 mb-1'>Organization *</div>
                    <Autocomplete
                        size="small"
                        options={organizationOptions}
                        getOptionLabel={(option) => option?.Name || ""}
                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                        onChange={(_event, value) => {
                            props.OnChangeOrg(value?.ID || "")
                        }}
                        value={selectedOrganization}
                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                        renderOption={(defaultprops, option) => (
                            <li {...defaultprops} className={"c-pointer h2 color-primary-dark p-1 d-flex justify-between w-p-90"}>
                                {option?.Name}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select organization"
                                name="OrganizationId"
                                variant="outlined"
                            />
                        )}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '0.75rem'
                            }
                        }}
                    />

                    <ImportStepFooter
                        backLabel={buttonLabels.CANCEL}
                        onBack={props.OnCancel}
                        continueLabel="Continue to upload →"
                        onContinue={props.OnContinue}
                        canContinue={canContinue}
                    />
                </>
            }
            right={
                <>
                    <ImportStepCard isDarkMode={props.IsDarkMode} className="mb-2">
                        <div className='h3-medium color-primary-accent'>Why we ask first</div>
                        <div className='h5-regular color-text-field-label mt-1'>
                            Organization is the same for the whole batch, so it lives here instead of repeating on every row. Your file only carries what changes per user.
                        </div>
                    </ImportStepCard>
                    <ImportStepCard isDarkMode={props.IsDarkMode}>
                        <div className='h3-medium color-primary-accent'>Your file needs eight columns</div>
                        <div className='d-flex flex-wrap mt-2'>
                            {USER_IMPORT_COLUMNS.map((column) => (
                                <ImportColumnChip key={column.label} label={column.label} required={column.required} />
                            ))}
                        </div>
                        <div className='h5-regular color-text-field-label mt-1'>
                            Next step has the template download.
                        </div>
                    </ImportStepCard>
                </>
            }
        />
    )
}

export default SelectOrganizationStep
